import { client } from '../lib/sanity'

export async function getProducts() {
  const query = `*[_type == "product"]{
    _id,
    name,
    description,
    features,
    "imageUrl": image.asset->url,
    "brochureUrl": brochure.asset->url,
    category->{
      _id,
      name
    }
  }`

  const products = await client.fetch(query)
  return products
}
